import { Link } from 'react-router-dom';
import '../../css/frames.css';
import { txt } from '../../services/translation';
import Logo from './Logo';
import LanguageSwitcher from '../Tools/LanguageSwitcher';

export default function Basic({center, children}){

    
    return <main className="basic-main">

        <section className="basic-section-left">
            
            <Logo 
                size={window.innerWidth < 900 ? 200 : 340}
            />

            <p>
                <span>
                {txt('needHelp')}
                </span>
                <br />
                <span>
                    <a href="tel:+33554547771">05 54 54 77 71</a>
                    <span>&ensp;&bull;&ensp;</span>
                    <Link to="/faq">FAQ</Link>
                    <span>&ensp;&bull;&ensp;</span>
                    <a href="https://www.learnylib.com/legal/accessibilites">{txt('accessibility')}</a>
                </span>
            </p>
            
            <LanguageSwitcher />

        </section>

        <section className={'basic-section-right ' + (center ? 'basic-center-content' : '')}>
            
            <div className='basic-content'>
                {children}
            </div>

        </section>
        
    </main>
}
